<template>
<v-card>

  <v-toolbar dark  color="#273C51" flat  height="42">
  <slot name="icon"> <v-icon>{{init.header.icon}}</v-icon>  </slot>
       <v-toolbar-title>
          <slot name="header"> {{init.header.text}} </slot>
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <slot name="icons">
      <v-icon v-for="item of init.header.icons" @click="$emit('f',item.f)">
        {{item.name}}
      </v-icon>
    </slot>

  </v-toolbar>

    <slot name="snackbar">
      <v-snackbar
        v-model="init.sb.snackbar"
        :color="init.sb.color"
        center top
         absolute
        :timeout="2000"

      >
        {{ init.sb.text  }}
        <v-btn
          dark
          flat
          @click="init.sb.snackbar = false"
        >
          ОК
        </v-btn>
      </v-snackbar>
    </slot>


<v-card-text>
<v-layout>

<slot name="links">
<b-tabs style="margin-left:5px">
<div v-for="item of init.bar.items">
<b-tab :id="item.id"  @click="changeMode(item.itemName)"  >
<span  slot="title"> {{item.text}} {{init.content.items[item.itemName].foundData.foundIds.length}}   </span>
</b-tab>
</div>
</b-tabs>
</slot>

<v-spacer></v-spacer>

<slot name="status" style="margin-top:5px">
<slot v-if="init.bar.status.length>0" ><span style="color:#707070; font-size:1.2em">{{init.bar.status}}</span></slot>
<slot v-else name="moreFunc"> </slot>
</slot>

</v-layout>



<v-layout fluid>

  <div style="border-radius:3px; margin:5px;border:solid #E3E4E8 1px;min-height:500px;max-height:500px;overflow-x:hidden;overflow-y:scroll; width:600px">


<slot name="content" >
    <div v-if="path.foundIds.length <= 0"  class="text-xs-center"  style="margin:25px;color:#858585; font-size:1.4em">
    <span>Нет данных для отображения </span>
    </div>
    <app-page-template  v-if="init.content.type=='pages'"  :foundData='path'> </app-page-template>
    <app-group-template  v-if="init.content.type=='groups'"  :foundData='path'> </app-group-template>
    <app-video-template  v-if="init.content.type=='videos'"  :foundData='path'> </app-video-template>
    <app-topic-template  v-if="init.content.type=='topics'"  :foundData='path'> </app-topic-template>
    <app-post-template  v-if="init.content.type=='posts'"  :foundData='path'> </app-post-template>
</slot>

<slot name="starter"> </slot>
</div>



<div style="padding:5px">
<slot name="meneger">
<app-meneger     :contentMenegment="menegerPath" :foundData="path"></app-meneger>
</slot>
<slot name="operations">  </slot>
</div>

</v-layout>

<v-layout><slot name="additinalLayout"></slot></v-layout>

</v-card-text>
</v-card>

</template>

<script>


export default {
  props:['init' ],
  data () {
    return {
selected: "green",
defaultColor: "#4A76A8",


    }
  },
methods:{
  changeMode(mode){
    this.init.selectedItem = mode
  },
},
computed:{
  path(){
    return this.init.content.items[this.init.selectedItem].foundData
  },
  menegerPath(){
    return this.init.content.items[this.init.selectedItem].meneger
  },
}
}
</script>
<style>
.tabs { color: #4A76A8;}
</style>
